// Export the Component Definition for use in Contentful Studio
export {LabSnapshotContentfulComponentDefinition} from './LabSnapshotContentfulDefinition';
export {default} from './LabSnapshot';
